import React from "react";
import PlansSectionHeader from "./PlansSectionHeader";
import RegisterSection from "./RegisterSection";
import moment from "moment";

const PlansSectionGuest = ({ freeUntil }) => {
  const isFreePeriod = moment(freeUntil).isAfter(moment());

  return (
    <>
      <PlansSectionHeader
        title={""}
        description={""}
      />

      <hr className="w-full border-gray-500 border-b-1 my-8" />

      <div className="flex flex-col justify-center items-center px-8">
        <RegisterSection color="text-black" />
      </div>
    </>
  );
};

export default PlansSectionGuest;
